export default "__VITE_ASSET__Bfzylvt7__"